import { render, staticRenderFns } from "./OrdenNew.vue?vue&type=template&id=27b0397a&scoped=true&"
import script from "./OrdenNew.vue?vue&type=script&lang=js&"
export * from "./OrdenNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b0397a",
  null
  
)

export default component.exports